const sizes = ["", "K", "M", "G"];
const KILO_CONSTANT = 1000;

const toFormattedGeoTokensAmount = (amount, decimals = 2) => {
  if (amount === 0 || amount === "0") return amount;

  const i = Math.floor(Math.log(amount) / Math.log(KILO_CONSTANT));

  return `${parseFloat(
    (amount / Math.pow(KILO_CONSTANT, i)).toFixed(decimals)
  )}${sizes[i]}`;
};

export { toFormattedGeoTokensAmount };
